<app-navbar
	><button mat-raised-button color="warn" routerLink="../">
		<i class="fas fa-chevron-left me-2"></i>Powrót
	</button></app-navbar
>
<mat-card appearance="outlined" class="my-3 mx-5">
	<mat-card-content>
		<app-reservation-message-dialog></app-reservation-message-dialog>
	</mat-card-content>
</mat-card>
